import { render } from "./SceletonNewsFullPreview.vue?vue&type=template&id=0d675f0f&scoped=true"
import script from "./SceletonNewsFullPreview.vue?vue&type=script&lang=js"
export * from "./SceletonNewsFullPreview.vue?vue&type=script&lang=js"

import "./SceletonNewsFullPreview.vue?vue&type=style&index=0&id=0d675f0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d675f0f"]])

export default __exports__